import { useEffect, useState } from "react";
import { Button, Paper, Stack, Table, TableBody, TableCell, TableHead, TablePagination, TableRow } from "@mui/material";
import CardModal from "../components/CardModal";
import { deleteCard, listCardsPaged } from "../api/cards";
import { EmptyState, PageHeader } from "../components/ui";

function marketLabel(code) {
  if (String(code) === "01") return "Dış (01)";
  if (String(code) === "02") return "İç (02)";
  return "";
}

function getCustomerType(row) {
  return row?.customer_type || row?.market_code || "";
}

function getCustomerCode(row) {
  return row?.code || row?.customer_code || "";
}

function Customers() {
  const [list, setList] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [total, setTotal] = useState(0);

  function reload() {
    listCardsPaged({ type: "customer", page: page + 1, limit: rowsPerPage }).then((data) => {
      setList(data?.items || []);
      setTotal(Number(data?.total || 0));
    });
  }

  useEffect(() => {
    reload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage]);

  function remove(id) {
    if (!window.confirm("Silmek istiyor musun?")) return;

    deleteCard(id).then(() => {
      reload();
    });
  }

  return (
    <Stack spacing={2}>
      <PageHeader
        title="Müşteriler"
        subtitle="Müşteri kartlarını yönetin."
        actions={
          <Button
            variant="contained"
            onClick={() => {
              setSelected(null);
              setModalOpen(true);
            }}
          >
            + Yeni Müşteri
          </Button>
        }
      />

      {!list.length ? (
        <EmptyState description="Henüz müşteri kartı yok." actionLabel="+ Yeni Müşteri" onAction={() => setModalOpen(true)} />
      ) : (
        <Paper>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Ad</TableCell>
                <TableCell>Müşteri Kodu</TableCell>
                <TableCell>İç/Dış Piyasa</TableCell>
                <TableCell>Telefon</TableCell>
                <TableCell>Adres / Şehir</TableCell>
                <TableCell align="right">İşlemler</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {list.map((x) => (
                <TableRow key={x.id} hover>
                  <TableCell>{x.name}</TableCell>
                  <TableCell>{getCustomerCode(x)}</TableCell>
                  <TableCell>{marketLabel(getCustomerType(x))}</TableCell>
                  <TableCell>{x.phone || ""}</TableCell>
                  <TableCell>{x.address || ""}</TableCell>
                  <TableCell align="right">
                    <Stack direction="row" spacing={1} justifyContent="flex-end">
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => {
                          setSelected(x);
                          setModalOpen(true);
                        }}
                      >
                        Düzenle
                      </Button>
                      <Button size="small" color="error" variant="outlined" onClick={() => remove(x.id)}>
                        Sil
                      </Button>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            component="div"
            count={total}
            page={page}
            onPageChange={(_, newPage) => setPage(newPage)}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setPage(0);
            }}
            rowsPerPageOptions={[10, 25, 50, 100]}
            labelRowsPerPage="Sayfa başına kayıt"
          />
        </Paper>
      )}

      {modalOpen ? (
        <CardModal
          type="customer"
          data={selected}
          onClose={() => setModalOpen(false)}
          onSaved={() => reload()}
        />
      ) : null}

    </Stack>
  );
}

export default Customers;
